import { AddVerifierToCompanyModel } from 'types/dynamic-forms/companies/AddVerifierToCompanyModel';
import { axiosInstance } from './apiCommon';
import { AddVerifierToCompanyResult } from 'types/dynamic-forms/companies/AddVerifierToCompanyResult';
import { AddPractitionerToCompanyResult } from 'types/dynamic-forms/companies/AddPractitionerToCompanyResult';
import { AddPractitionerToCompanyModel } from 'types/dynamic-forms/companies/AddPractitionerToCompanyModel';
import { LcaPractitionerCompanyModel } from 'types/dynamic-forms/companies/LcaPractitionerCompanyModel';

export const getLcaPractitionerCompanies = async (countryId?: string) =>
  (
    await axiosInstance.get<LcaPractitionerCompanyModel[]>('/api/v1/dynamic-forms/companies/lca-practitioner-companies', {
      params: { countryId },
    })
  ).data;

export const postAddVerifierToCompany = async (companyId: string, model: AddVerifierToCompanyModel) =>
  (await axiosInstance.post<AddVerifierToCompanyResult>(`/api/v1/dynamic-forms/companies/${companyId}/verifiers`, model))
    .data;


export const postAddPractitionerToCompany = async (companyId: string, model: AddPractitionerToCompanyModel) =>
  (await axiosInstance.post<AddPractitionerToCompanyResult>(`/api/v1/dynamic-forms/companies/${companyId}/lca-practitioners`, model))
    .data;


export const postRequestLcaPractitionerCollaboration = async (companyId: string, targetCompanyId: string) =>
  (await axiosInstance.post<void>(`/api/v1/dynamic-forms/companies/${companyId}/request-lca-collaboration`, { companyId: targetCompanyId }))
    .data;